import { useState } from 'react';
import { useForm } from 'react-hook-form';

import { PayrunApproverCreate } from '@xemplo/gp-types';
import { useModalDialog } from '@xemplo/modal-dialog';
import { useCreatePayrunApprovers } from '@xemplo/payrun-query';
import { ToastType, useToast } from '@xemplo/toast';

import { FormFields, UsePayrunApproversProps } from './create-payrun-approvers.types';

const DEFAULT_ERROR_MESSAGE = 'An unexpected error occurred. Please try again later.';

export const useCreatePayrunApprover = (props: Readonly<UsePayrunApproversProps>) => {
  const { companyId } = props;

  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const methods = useForm<FormFields>({
    defaultValues: {
      payrunType: null,
      paySchedules: [],
      selectedUsers: [],
    },
  });

  //Modal Dialog Setup
  const modalDialog = useModalDialog({
    id: 'payrun-approver-modal',
  });

  const { addToast } = useToast();

  const handleSuccessfulCreate = () => {
    addToast({
      text: `Payrun approver added`,
      type: ToastType.Confirmation,
    });
    methods.reset();
    modalDialog.closeDialog();
  };

  const { mutateAsync } = useCreatePayrunApprovers({
    onSuccess: () => {
      handleSuccessfulCreate();
    },
    onError: (error) => {
      const errorMessage = error?.response?.data?.validationErrors?.errors[0].message;
      setErrorMessage(errorMessage ?? DEFAULT_ERROR_MESSAGE);
    },
    companyId: companyId ?? '',
  });

  const preparePayload = (data: FormFields) => {
    const payLoad: PayrunApproverCreate[] =
      data.selectedUsers?.map(
        (user): PayrunApproverCreate => ({
          userId: user,
          payrunTypeId: Number(data.payrunType),
          payscheduleIds: data.paySchedules ?? [],
        })
      ) ?? [];
    return payLoad;
  };

  const handleSubmit = methods.handleSubmit(async (data: FormFields) => {
    const payload = preparePayload(data);
    return mutateAsync(payload);
  });

  return {
    modalDialog,
    handleSubmit,
    errorMessage,
    setErrorMessage,
    methods,
  };
};
